import { filterRequest } from 'rxOperators/filterRequestOfType'
import { mergeMapAsync } from 'rxOperators/mergeMapAsync'
import { EpicRefined } from 'interfaces/middleware'
import { CCOnboardingActions, GetCCShipmentAddressAction } from 'components/features/creditCard/creditCardStore/actions'
import { gqlCCShipmentAddressQuery } from 'queries/shipmentAddressQuery'


export const ccShipmentAddressEpic: EpicRefined<CCOnboardingActions> = (action$) => action$.pipe(
  filterRequest(GetCCShipmentAddressAction.type),
  mergeMapAsync(async (action) => {
    try {
      const result = await gqlCCShipmentAddressQuery()
      if (!result.error) {
        return action.success(result.data.current_user.shipment_address)
      }

      return action.fail({ errorCode: 400 })
    } catch (e) {
      return action.fail({ errorCode: 400 })
    }
  }),
)
